import PropTypes from 'prop-types';
import { NavLink as RouterLink } from 'react-router-dom';
// @mui
import { Box, List, ListItemText, Typography } from '@mui/material';
//
import { StyledNavItem, StyledNavItemIcon } from './styles';

// ----------------------------------------------------------------------

NavSection.propTypes = {
  data: PropTypes.array,
};

export default function NavSection({ data = [], role, ...other }) {
  return (
    <Box {...other}>
      <List disablePadding sx={{ p: 1 }}>
        {data
          .filter((item) => !(role === "platformAdmin" && item.title === "Admin")) // Exclude "admin" for superadmin role
          .map((item) => (
            <NavItem key={item.title} item={item} />
          ))}
      </List>
    </Box>
  );
}


// ----------------------------------------------------------------------

NavItem.propTypes = {
  item: PropTypes.object,
};

function NavItem({ item }) {
  const { title, path, icon, info } = item;

  return (
    <StyledNavItem
      component={RouterLink}
      to={path}
      sx={{
        color:'#fff',

        m:1,
        width:210,
        '&.active': {
          color: '#82E0AA',
          // bgcolor: '#fff',
          border: '1px solid #82E0AA',
          borderRadius:2,
        },
      }}
    >
      <StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>

      {/* <Typography >{title}</Typography> */}
      <ListItemText disableTypography primary={title} sx={{ml:1.5}} />

      {info && info}
    </StyledNavItem>
  );
}
